import { z } from 'zod';
import { claimContentSchema, claimLocaleSchema } from './claim-section';

export const claimTypeSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(50),
  path: z.string().min(1, 'Path is required').max(100),
  i18n: z.object({
    es: claimLocaleSchema,
  }),
  content: claimContentSchema,
});

export type ClaimTypeInput = z.infer<typeof claimTypeSchema>;
